import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/badge-confirmation-general.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-25481218")

_pushScopeId("data-v-25481218")
const _hoisted_1 = { class: "flex flex-col items-center gap-y-6" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "w-36 h-36 flex items-center justify-center" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    class: "w-full h-full",
    alt: "confirmation"
  })
], -1)
const _hoisted_3 = { class: "flex flex-col items-center gap-y-2" }
const _hoisted_4 = { class: "text-center text-sm font-semibold text-gray-lp-300 leading-4" }
const _hoisted_5 = { class: "text-center text-xs text-gray-lp-800 leading-4" }
const _hoisted_6 = { class: "items-center mx-auto flex flex-row text-xs gap-x-6" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_ModalV2 = _resolveComponent("ModalV2")!

  return (_ctx.isOpen)
    ? (_openBlock(), _createBlock(_component_ModalV2, {
        key: 0,
        width: "pickup-active-pickup-warning",
        onClose: _ctx.onCancel,
        showBorderTitle: false,
        titlePadding: 'p-0',
        contentPadding: 'px-8 pt-6 pb-0',
        footerPadding: 'px-8 py-6',
        marginHeader: 'mb-0',
        marginFooter: 'mt-0',
        isShadows: false,
        showFooter: true,
        closeButtonTestId: 'pickup-active-pickup-warning-button-close',
        footerBgColor: 'bg-white',
        borderTop: 'border-t-0'
      }, {
        content: _withId(() => [
          _createVNode("div", _hoisted_1, [
            _hoisted_2,
            _createVNode("div", _hoisted_3, [
              _createVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t("pickup.activePickupWarning.title")), 1),
              _createVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("pickup.activePickupWarning.body")), 1)
            ])
          ])
        ]),
        footer: _withId(() => [
          _createVNode("div", _hoisted_6, [
            _createVNode(_component_LpButton, {
              isWidthFull: "",
              title: _ctx.$t('pickup.activePickupWarning.buttonBack'),
              outline: "",
              textColor: "red-lp-2400",
              color: "red-lp-2400",
              customClass: "py-3",
              "data-testid": "pickup-active-pickup-warning-button-back",
              onClick: _ctx.onCancel
            }, null, 8, ["title", "onClick"]),
            _createVNode(_component_LpButton, {
              isWidthFull: "",
              title: _ctx.$t('pickup.activePickupWarning.buttonConfirm'),
              textColor: "white",
              color: "red-lp-2400",
              customClass: "py-3",
              "data-testid": "pickup-active-pickup-warning-button-confirm",
              onClick: _ctx.onConfirm
            }, null, 8, ["title", "onClick"])
          ])
        ]),
        _: 1
      }, 8, ["onClose"]))
    : _createCommentVNode("", true)
})